/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsArrowDownFromLine: {
  name: 'arrow-down-from-line';
  data: string;
} = {
  name: 'arrow-down-from-line',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M11 6H7a1 1 0 1 1 0-2h10a1 1 0 1 1 0 2h-4v10.865l4.36-3.633a1 1 0 1 1 1.28 1.536l-6 5a1 1 0 0 1-1.28 0l-6-5a1 1 0 1 1 1.28-1.536L11 16.865V6Z" fill="currentColor"/></svg>`,
};
